/**
 * 使用 douban://douban.com/toast 弹窗 rexxar toast
 */

import { isFrodo } from '@douban/fe-utils'
import { assemblePayload, callUri } from '@douban/rexxar-web'

export type Level = 'info' | 'error' | 'fatal';
export const URI = 'douban://douban.com/toast'

export function CallRexxarToast(level: Level, message: string) {
  callUri(`${URI}${assemblePayload({ level,
    message })}`)
}

export function CallToast(level: Level, message: string) {
  if (isFrodo()) {
    CallRexxarToast(level, message)
  } else {
    window.alert(message)
  }
}
